import React from 'react';
import { IdPrefixProvider } from '@jbhi-fi/components/src/IdPrefix';
import { Footer } from './Footer';
import { Portal } from '../../../components/portal/Portal';

const FOOTER_CONTAINER_ID = 'react-root-footer';

export const FooterPortal = () => {
  const container = window.document.getElementById(FOOTER_CONTAINER_ID);
  if (!container) return null;

  return (
    <Portal container={container}>
      <IdPrefixProvider prefix="footer">
        <Footer />
      </IdPrefixProvider>
    </Portal>
  );
};
